module.exports = __webpack_public_path__ + "static/img/paperbj.0b007e1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/newCourse/paperbj.png
// module id = Tn+u
// module chunks = 96